// components/subscription/SubscriptionHistory.jsx
import React, { useEffect } from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const SubscriptionHistoryList = () => {
  const { 
    subscriptionHistory, 
    fetchSubscriptionHistory, 
    loading, 
    error 
  } = useSubscription();

  useEffect(() => {
    fetchSubscriptionHistory();
  });

  if (loading) return <div className="text-center py-8">Loading history...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!subscriptionHistory || subscriptionHistory.length === 0) {
    return <div className="text-center py-8">No subscription history found</div>;
  }
  console.log(subscriptionHistory, typeof(subscriptionHistory));
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Subscription History</h2>
      
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Plan
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Start Date
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                End Date
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Amount
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {subscriptionHistory.history.map((sub) => (
              <tr key={sub.id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{sub.plan_name}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-500">
                    {new Date(sub.start_time).toLocaleDateString()}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-500">
                    {new Date(sub.expires_at).toLocaleDateString()}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                    sub.status === 'active'
                      ? 'bg-green-100 text-green-800'
                      : sub.status === 'canceled'
                      ? 'bg-red-100 text-red-800'
                      : sub.status === 'expired'
                      ? 'bg-gray-100 text-gray-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {sub.status.toUpperCase()}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  ₹{parseFloat(sub.amount_paid).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SubscriptionHistoryList;